import React, { useMemo } from "react";
import { LogIn, LogOut, Wallet, TrendingUp } from "lucide-react";

const eur = (n) => new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(n || 0) + " €";
const iso = (d) => (d ? new Date(d + "T00:00:00") : null);

export default function BookingsRecap({ rows }) {
  const stats = useMemo(() => {
    const list = Array.isArray(rows) ? rows : [];
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const in7 = new Date(today); in7.setDate(in7.getDate() + 7);
    const active = list.filter((b) => (b.status || "").toLowerCase() !== "cancelled" && (b.status || "").toLowerCase() !== "annulée");
    const inRange = (d) => { const x = iso(d); return x && x >= today && x <= in7; };
    const arrivals = active.filter((b) => inRange(b.arrivee)).length;
    const departures = active.filter((b) => inRange(b.depart)).length;
    const deposits = active.reduce((s, b) => s + ((b.payment_status === "paid" || (b.paid_amount || 0) > 0) ? (b.paid_amount || b.deposit || 0) : 0), 0);
    const pending = active.reduce((s, b) => {
      const dep = iso(b.depart);
      const upcoming = dep && dep >= today;
      return s + (upcoming && (b.payment_status === "paid") ? (b.balance || 0) : 0);
    }, 0);
    return { arrivals, departures, deposits, pending };
  }, [rows]);

  const cards = [
    ["Arrivées (7 j)", stats.arrivals, LogIn],
    ["Départs (7 j)", stats.departures, LogOut],
    ["Acomptes encaissés", eur(stats.deposits), Wallet],
    ["Soldes à percevoir", eur(stats.pending), TrendingUp],
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-5" data-testid="bookings-recap">
      {cards.map(([label, val, Icon], i) => (
        <div key={i} className="bg-white rounded-2xl border border-black/5 p-4">
          <Icon size={18} className="text-brand mb-2" strokeWidth={1.5} />
          <div className="font-heading text-xl text-ink-900 tabular-nums" data-testid={`recap-card-${i}`}>{val}</div>
          <div className="text-xs text-ink-400 mt-0.5">{label}</div>
        </div>
      ))}
    </div>
  );
}
